import { render } from "./ModulesTab.vue?vue&type=template&id=61c8776b"
import script from "./ModulesTab.vue?vue&type=script&lang=js"
export * from "./ModulesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__